import { iconFactory } from '../iconFactory'

export const Tag = iconFactory(
  'Tag',
  ({ fill }) => (
    <>
      <path
        d="M18.341 9.64984L10.841 2.14984C10.541 1.84984 10.1243 1.6665 9.66602 1.6665H3.83268C2.91602 1.6665 2.16602 2.4165 2.16602 3.33317V9.1665C2.16602 9.62484 2.34935 10.0415 2.65768 10.3498L10.1577 17.8498C10.4577 18.1498 10.8743 18.3332 11.3327 18.3332C11.791 18.3332 12.2077 18.1498 12.5077 17.8415L18.341 12.0082C18.6493 11.7082 18.8327 11.2915 18.8327 10.8332C18.8327 10.3748 18.641 9.94984 18.341 9.64984ZM11.3327 16.6748L3.83268 9.1665V3.33317H9.66602V3.32484L17.166 10.8248L11.3327 16.6748Z"
        fill={fill}
      />
      <path
        d="M5.91602 6.6665C6.60637 6.6665 7.16602 6.10686 7.16602 5.4165C7.16602 4.72615 6.60637 4.1665 5.91602 4.1665C5.22566 4.1665 4.66602 4.72615 4.66602 5.4165C4.66602 6.10686 5.22566 6.6665 5.91602 6.6665Z"
        fill={fill}
      />
    </>
  ),
  { viewBox: '0 0 20 20', height: '20px', width: '20px' },
)
